export enum ESourceStep {
  SelectBaseline = 0,
  ImportOption = 1,
  LinkOrFile = 2,
  Docs = 3,
}
